import { ENDPOINTS } from 'config/endpoints';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { UpdateProspectAccount } from 'crono-fe-common/types/DTO/updateProspectAccount';
import { Prospect } from 'crono-fe-common/types/prospect';
import { invalidateTimelineQueries } from 'hooks/services/timeline/useSearchTimeline';

export default function usePatchProspectAccount() {
  const queryClient = useQueryClient();

  const patchProspectAccount = (updateProspect: UpdateProspectAccount) => {
    const request: Request = {
      url: `${ENDPOINTS.prospect.account}`,
      config: {
        method: 'patch',
        data: { data: updateProspect },
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<
    Response<Prospect>,
    CronoError,
    UpdateProspectAccount
  >(patchProspectAccount, {
    onSettled: () => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey.toString().startsWith(ENDPOINTS.account.main) ||
          query.queryKey.toString().startsWith(ENDPOINTS.prospect.main) ||
          query.queryKey.toString().startsWith(ENDPOINTS.prospect.search.main),
      });
      queryClient.invalidateQueries([ENDPOINTS.prospect.main]);
      queryClient.invalidateQueries([ENDPOINTS.account.search.main]);
      queryClient.invalidateQueries([ENDPOINTS.task.search]);
      invalidateTimelineQueries(queryClient);
      queryClient.invalidateQueries([ENDPOINTS.task.main]);
    },
  });

  return { data, mutate, ...rest };
}
